<template>
  <register-container fluid fullHeight>
    <template slot="header">{{ pageTitle || 'Are you a new or returning patient?' }}</template>
    <template slot="subtitle">{{ pageSubtitle }} </template>
    <div
      class="choice-container d-flex justify-space-around mt-6 mb-6"
      :class="{ 'flex-column': $vuetify.breakpoint.mdAndDown }"
      :style="{ gap: '16px' }"
    >
      <div>
        <hover-button
          :disabled="loading"
          @click="goNext(false)"
          :block="$vuetify.breakpoint.mdAndDown"
          >{{ buttonTextNew }}</hover-button
        >
      </div>
      <div>
        <hover-button
          :disabled="loading"
          @click="goNext(true)"
          :block="$vuetify.breakpoint.mdAndDown"
          >{{ buttonTextReturning }}</hover-button
        >
      </div>
    </div>
  </register-container>
</template>
<style scoped>
.choice-container {
  width: 100%;
}
</style>
<script>
import HoverButton from '../components/HoverButton.vue';
import RegisterContainer from '../components/RegisterContainer.vue';

export default {
  name: 'RegisterNewReturning',
  components: { HoverButton, RegisterContainer },
  data() {
    return {
      buttonTextNew: 'New',
      buttonTextReturning: 'Returning',
      loading: false,
    };
  },
  methods: {
    async goNext(isReturningPatient) {
      await this.$store.commit('setRegistration', { isReturningPatient });
      this.$emit('next');
    },
  },
};
</script>
